import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { shallowEqual } from "helpers/utilities";
import { errorMsg } from "redux/reducers/snackMsgsReducers";
import i18n from "i18n";
import cockpitActions from "redux/actions/cockpitActions";
import {
	ListItemIcon,
	ListItemText,
	Menu,
	Tooltip,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button
} from "@material-ui/core";
import { IconButton, MenuItem } from "@mui/material";
import AvTimerOutlinedIcon from "@material-ui/icons/AvTimerOutlined";
import { Box } from "@mui/system";
import DoneOutlineOutlinedIcon from "@material-ui/icons/DoneOutlineOutlined";
import BallotOutlinedIcon from "@material-ui/icons/BallotOutlined";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import SendIcon from "@material-ui/icons/Send";
import lod_ from "lodash";
import { ModalResolved } from "../ConvActions/ConvItemComponents";

const DropDownMenu = ({
	anchorEl,
	setAnchorEl,
	emailCCListGlobal,
	emailBCCListGlobal,
	emailRecipientsListGlobal,
	answer
}) => {
	const dispatch = useDispatch();
	const { selectedConversation, convSending, currentMessage, attachments, topicDraft, urgent } =
		useSelector(state => state.cockpit, shallowEqual);
	const { assistantconfig } = useSelector(state => state);
	const { sendEnabled } = useSelector(state => state.conversation);
	const { cockpit } = useSelector(state => state.assistantconfig);
	const engageContact = useSelector(state => state?.engage?.contact);
	const [open, setOpen] = useState(false);
	const [actionSend, setActionSend] = useState(false);
	const [CC, setCC] = useState([]);
	const [BCC, setBCC] = useState([]);
	const [recipients, setRecipients] = useState([]);
	const [state, setState] = useState(null);
	const [substate, setSubstate] = useState(null);
	const [messageDialogAnswer, setMessageDialogAnswer] = useState("");
	const handleClickOpen = () => {
		setOpen(true);
	};

	const [convContact, setConvContact] = React.useState([]);

	const [openModalResolved, setOpenModalResolved] = React.useState(false);

	const handleClose = () => {
		setOpen(false);
	};

	let noTopic =
		assistantconfig?.cockpit?.topicMandatory &&
		(!selectedConversation.meta.topic ||
			selectedConversation.meta.topic === "nointent" ||
			!assistantconfig.intents.some(obj => obj.code === selectedConversation.meta.topic));

	let disableSend = assistantconfig?.cockpit?.topicMandatory
		? (sendEnabled && answer === "") ||
			!selectedConversation.meta.topic ||
			selectedConversation.meta.topic === "nointent" ||
			!assistantconfig.intents.some(obj => obj.code === selectedConversation.meta.topic)
		: sendEnabled && answer === "";

	const handleCloseDropDown = () => {
		setAnchorEl(null);
	};

	/**
	 * Checks the conditions related to the conversation channel before sending.
	 * Updates the confirmation message and the allowed action, then opens the
	 * confirmation dialog.
	 * @param {string} message - The message to display in the dialog.
	 * @param {boolean} handleAction - Indicates whether the send action should be allowed.
	 * @param {string} target - Targeted context (e.g., "message", "subject", "all").
	 * @returns {void}
	 */
	const handleCheckConditionChannelForSend = (message, handleAction, target) => {
		let conditionChannel = handleAction;
		let messagePopUp = message;

		// If the conversation has a channel code, try to find the matching channel
		// and apply channel-specific rules that may override the default behaviour.
		if (!lod_.isNil(selectedConversation?.header?.extra?.channelCode) && handleAction === true) {
			let channel = assistantconfig?.channels.find(
				c => c.code === selectedConversation.header.extra.channelCode
			);

			if (!lod_.isNil(channel) && !lod_.isEmpty(channel)) {
				switch (channel?.subType) {
					// Microsoft channels require a different confirmation flow when sending
					// a message with no response: block automatic send and change dialog text.
					case "MSFT":
						if (target === "message") {
							conditionChannel = false;
							messagePopUp = i18n.t("COC.noSendSendNoResponse");
						}
						break;
					default:
						break;
				}
			}
		}

		// update state used by the confirmation dialog and open it
		setMessageDialogAnswer(messagePopUp);
		setActionSend(conditionChannel);

		handleClickOpen();
	};

	/**
	 *
	 * @param {*} emailCCListGlobal
	 * @param {*} emailBCCListGlobal
	 * @param {*} emailRecipientsListGlobal
	 * @param {*} urgent
	 * @param {*} state
	 * @param {*} substate
	 */
	const handleConv = (
		emailCCListGlobal,
		emailBCCListGlobal,
		emailRecipientsListGlobal,
		urgent,
		state,
		substate,
		conversationsAlreadyResolved = null,
		success = null
	) => {
		handleCloseDropDown();
		if (sendEnabled) {
			let OKtoSend = true;
			const totalAttachmentSizeLimit = cockpit?.outgoingMailMaxSizeInMeg;

			if (totalAttachmentSizeLimit) {
				// Are we over the limit?
				let totalAttachmentSize = 0;
				attachments.forEach(att => {
					totalAttachmentSize += att.size;
				});
				totalAttachmentSize = parseFloat(totalAttachmentSize / (1024 * 1024));

				if (totalAttachmentSize > totalAttachmentSizeLimit) {
					dispatch(
						errorMsg(
							`${i18n.t(
								"EDIT_FORM.error_messages.attachmentsSizeOverLimit"
							)}${totalAttachmentSizeLimit} MB`
						)
					);
					OKtoSend = false;
				}
			}

			if (OKtoSend) {
				let testAnwser = document.createElement("div");
				testAnwser.innerHTML = answer;

				// Extraire la réponse pour tester si elle est vide
				let text = testAnwser.textContent || testAnwser.innerText;
				let anwserNotEmpty = /\S/.test(text);
				let topicNotEmpty = /\S/.test(topicDraft);

				setCC(emailCCListGlobal);
				setBCC(emailBCCListGlobal);
				setRecipients(emailRecipientsListGlobal);
				setState(state);
				setSubstate(substate);

				if (
					engageContact === "" &&
					selectedConversation?.header?.channel === "ML" &&
					selectedConversation?.header?.substate === "draft"
				) {
					handleCheckConditionChannelForSend(i18n.t("COC.noSendSendNoTo"), false, "engageContact");
				} else if (!anwserNotEmpty && !topicNotEmpty && !attachments?.length) {
					handleCheckConditionChannelForSend(i18n.t("COC.noSendSendNoSubject"), false, "all");
				} else if (!anwserNotEmpty) {
					handleCheckConditionChannelForSend(i18n.t("COC.confirmSendNoAnswer"), true, "message");
				} else if (!topicNotEmpty) {
					handleCheckConditionChannelForSend(i18n.t("COC.confirmSendNoSubject"), true, "subject");
				} else {
					dispatch(
						cockpitActions.sendAnswer({
							conv: selectedConversation,
							CC: emailCCListGlobal,
							BCC: emailBCCListGlobal,
							emailRecipients: emailRecipientsListGlobal,
							targetStates: { state, substate },
							manualTopic: topicDraft,
							urgent,
							answer,
							message: currentMessage,
							conversationsAlreadyResolved,
							success: success
						})
					);
				}
			}
		}
	};

	const sendConv = () => {
		dispatch(
			cockpitActions.sendAnswer({
				conv: selectedConversation,
				CC,
				BCC,
				emailRecipients: recipients,
				targetStates: { state, substate },
				manualTopic: topicDraft,
				urgent,
				answer,
				message: currentMessage
			})
		);
		setActionSend(false);
		handleClose();
	};

	const handleNeedConv = res => {
		setConvContact(res?.checkNeed?.conversations);
		setOpenModalResolved(true);
	};

	const sendAlreadyResolved = conversations => {
		if (!lod_.isEmpty(conversations) && !lod_.isNil(conversations)) {
			handleConv(
				emailCCListGlobal,
				emailBCCListGlobal,
				emailRecipientsListGlobal,
				urgent,
				"resolved",
				"resolved",
				conversations
			);
		} else {
			handleConv(
				emailCCListGlobal,
				emailBCCListGlobal,
				emailRecipientsListGlobal,
				urgent,
				"resolved",
				"resolved",
				[]
			);
		}
	};

	return (
		<Box>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleCloseDropDown}
			>
				<MenuItem
					onClick={() =>
						handleConv(
							emailCCListGlobal,
							emailBCCListGlobal,
							emailRecipientsListGlobal,
							urgent,
							"ongoing",
							"waiting_client"
						)
					}
				>
					<ListItemIcon>
						<AvTimerOutlinedIcon fontSize="small" mt={1} />
					</ListItemIcon>
					<ListItemText primary={i18n.t("COC.client")} />
				</MenuItem>
				<MenuItem
					onClick={() =>
						handleConv(
							emailCCListGlobal,
							emailBCCListGlobal,
							emailRecipientsListGlobal,
							urgent,
							"ongoing",
							"waiting_action"
						)
					}
				>
					<ListItemIcon>
						<BallotOutlinedIcon fontSize="small" mt={1} />
					</ListItemIcon>
					<ListItemText primary={i18n.t("COC.action")} />
				</MenuItem>
				<Tooltip title={noTopic ? i18n.t("COC.noTopic") : ""} placement="left">
					<span>
						<MenuItem
							disabled={disableSend}
							onClick={() =>
								handleConv(
									emailCCListGlobal,
									emailBCCListGlobal,
									emailRecipientsListGlobal,
									urgent,
									"resolved",
									"resolved",
									null,
									res => {
										handleNeedConv(res);
									}
								)
							}
						>
							<ListItemIcon>
								<DoneOutlineOutlinedIcon fontSize="small" mt={1} />
							</ListItemIcon>
							<ListItemText primary={i18n.t("COC.resolved")} />
						</MenuItem>
					</span>
				</Tooltip>
				{openModalResolved === true && (
					<ModalResolved
						openModalResolved={openModalResolved}
						setOpenModalResolved={setOpenModalResolved}
						convContact={convContact}
						action={"send"}
						actionToDo={conversations => sendAlreadyResolved(conversations)}
					/>
				)}
				<MenuItem
					onClick={() =>
						handleConv(
							emailCCListGlobal,
							emailBCCListGlobal,
							emailRecipientsListGlobal,
							urgent,
							"resolved",
							"watchlist"
						)
					}
				>
					<ListItemIcon>
						<RemoveRedEyeOutlinedIcon fontSize="small" mt={1} />
					</ListItemIcon>
					<ListItemText primary={i18n.t("COC.watchlist")} />
				</MenuItem>
			</Menu>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{i18n.t("COC.confirmSend")}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">{messageDialogAnswer}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						{i18n.t("COC.cancel")}
					</Button>
					{actionSend && (
						<Button onClick={sendConv} color="primary" autoFocus>
							{i18n.t("COC.send")}
						</Button>
					)}
				</DialogActions>
			</Dialog>
		</Box>
	);
};

export const SendMessageComponent = ({
	answer,
	emailBCCListGlobal,
	emailCCListGlobal,
	emailRecipientsListGlobal,
	loadingSend
}) => {
	const dispatch = useDispatch();
	const { selectedConversation, convSending, currentMessage, attachments } = useSelector(
		state => state.cockpit,
		shallowEqual
	);
	const cockpit = useSelector(state => state.assistantconfig?.cockpit) || {};

	const { sendEnabled } = useSelector(state => state.conversation);
	const engageContact = useSelector(state => state?.engage?.contact);
	const [anchorEl, setAnchorEl] = useState(null);

	const checkAnswerEmptyHTML = () => {
		let testAnwser = document.createElement("div");
		testAnwser.innerHTML = answer;

		let text = testAnwser.textContent || testAnwser.innerText;
		let anwserNotEmpty = /\S/.test(text);

		if (anwserNotEmpty) {
			return false;
		}

		return true;
	};

	const conversationHasNoContact = Boolean(
		!selectedConversation?.contact?.email &&
			!selectedConversation?.contact?.uid &&
			!selectedConversation?.contact?.id &&
			!engageContact
	); // Condition added for new engage

	let disableSendConversational =
		conversationHasNoContact ||
		convSending ||
		(sendEnabled && (answer === "" || !answer) && !attachments?.length) ||
		(selectedConversation.header.channel === "LC" &&
			!selectedConversation.meta?.cockpit?.connected);

	let disableSendFoMK =
		conversationHasNoContact || convSending || (sendEnabled && checkAnswerEmptyHTML());

	const typeConv = selectedConversation?.header.type;

	const checkPossibilities = disableSendConversational => {
		if (
			currentMessage?.message?.header?.type === "menu" &&
			!lod_.isNil(currentMessage?.message?.payload?.menu?.choices) &&
			!lod_.isEmpty(currentMessage?.message?.payload?.menu?.choices)
		) {
			return false;
		} else if (disableSendConversational) {
			return true;
		} else if (selectedConversation?.header?.channel === "MK" && disableSendFoMK) {
			return true;
		} else {
			return false;
		}
	};

	const handleClickDropDown = event => {
		setAnchorEl(event.currentTarget);
	};

	const sendAnswer = () => {
		if (
			!lod_.isNil(selectedConversation?.header?.channel) &&
			!lod_.isNil(answer) &&
			selectedConversation?.header?.channel === "GOPS"
		) {
			if (lod_.isNil(cockpit?.maxMessageLengthGooglePlayStore)) {
				dispatch(errorMsg(`${i18n.t("ANSWERS.errorMaxLenghtConfig")}`));
				return;
			}
			if (answer.length > cockpit.maxMessageLengthGooglePlayStore) {
				dispatch(
					errorMsg(`${i18n.t("ANSWERS.errorMaxLenght")} ${cockpit.maxMessageLengthGooglePlayStore}`)
				);
				return;
			}
		}
		dispatch(
			cockpitActions.sendAnswer({
				conv: selectedConversation,
				answer,
				message: currentMessage
			})
		);
	};

	return (
		<>
			<Tooltip title={i18n.t("COC.send")}>
				<Box>
					<IconButton
						size="small"
						disabled={
							loadingSend
								? selectedConversation?.header?.channel !== "ML"
									? checkPossibilities(disableSendConversational)
									: false
								: true
						}
						onClick={typeConv === "ticket" ? handleClickDropDown : () => sendAnswer()}
					>
						<SendIcon color={loadingSend ? "action" : "error"} />
					</IconButton>
				</Box>
			</Tooltip>

			<DropDownMenu
				emailCCListGlobal={emailCCListGlobal}
				emailBCCListGlobal={emailBCCListGlobal}
				emailRecipientsListGlobal={emailRecipientsListGlobal}
				answer={answer}
				anchorEl={anchorEl}
				setAnchorEl={setAnchorEl}
			/>
		</>
	);
};
